// Identidade visual — AAB Repairs Management System
// Empresa operacional (licença): AAB Repairs / Alex Auto Body
// Empresa fiscal / financeiro: GM Auto Service
// Sempre exibir ambas em documentos exportados (PDFs, e-mails, relatórios).

export const BRAND = {
  logoUrl:
    "https://customer-assets.emergentagent.com/job_repair-flow-hub-1/artifacts/6n3nspd0_IMG_0009.png",
  legalName: "AAB Repairs",
  tagline: "Alex Auto Body",
  fiscalName: "GM Auto Service",
  fiscalNote: "Faturamento por GM Auto Service · Operação sob licença AAB Repairs",
};
